/* ============================================================
   Built Strong — Shopify product template interactions
   Framework-free. Event-delegated where possible so it keeps
   working after Theme Editor section reloads. Per-section timers
   (carousel autoplay, sticky cart) re-init on shopify:section:load.
   ============================================================ */
(function () {
  'use strict';

  // Guard: this file may be referenced by several sections. Bind once.
  if (window.__npProductInit) return;
  window.__npProductInit = true;

  /* ---------- helpers ---------- */
  function closest(el, sel) { return el && el.closest ? el.closest(sel) : null; }

  /* ============================================================
     DELEGATED CLICK HANDLERS (bound once on document)
     ============================================================ */
  /* ============================================================
     ADD TO CART (theme-independent — no Dawn JS dependency)
     Fetches /cart/add.js, then renders + opens the cart drawer
     using Dawn's <cart-drawer>/<cart-notification> if present,
     otherwise falls back to the cart page.
     ============================================================ */
  function getRoute(name, fallback) {
    return (window.routes && window.routes[name]) ? window.routes[name] : fallback;
  }

  function refreshCartIcon() {
    // bump Dawn's cart bubble by re-fetching the section
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + '?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var bubble = document.getElementById('cart-icon-bubble');
        if (!bubble) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#cart-icon-bubble') || tmp.querySelector('.shopify-section') || tmp.firstElementChild;
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function addToCart(form, btn) {
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');
    var host = cartDrawer || cartNotification;

    var formData = new FormData(form);

    // Ask Shopify to return the cart sections so we can re-render the drawer
    if (host && typeof host.getSectionsToRender === 'function') {
      try {
  var ids = host.getSectionsToRender().map(function (s) { return s.id; });
  console.log('Cart sections requested:', ids);
  formData.append('sections', ids.join(','));
  formData.append('sections_url', window.location.pathname);
} catch (e) {}
    }

    if (btn) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      var btnLabel = btn.querySelector('span:first-child');
      if (btnLabel) { btn._origLabel = btnLabel.textContent; btnLabel.textContent = 'Adding\u2026'; }
    }

    fetch(getRoute('cart_add_url', '/cart/add'), {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          var lbl = btn.querySelector('span:first-child');
          if (lbl && btn._origLabel) lbl.textContent = btn._origLabel;
        }

        if (data && (data.status === 422 || data.status === 'bad_request' || data.message)) {
          showFormError(form, data.description || data.message || 'Could not add to cart.');
          return;
        }
        clearFormError(form);

        // Re-render + open the cart drawer
        if (cartDrawer) {
          if (data.sections && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(data);
          }
          cartDrawer.classList.remove('is-empty');
          openCartDrawer(cartDrawer);
        } else if (cartNotification && typeof cartNotification.renderContents === 'function' && data.sections) {
          cartNotification.renderContents(data);
        } else if (host && data.sections) {
          replaceCartSections(data.sections);
          if (cartDrawer) { cartDrawer.classList.remove('is-empty'); openCartDrawer(cartDrawer); }
        } else {
          window.location = getRoute('cart_url', '/cart');
          return;
        }
        document.dispatchEvent(new CustomEvent('np:cart:added', { detail: data, bubbles: true }));
      })
      .catch(function () {
        if (btn) {
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
          var lbl = btn.querySelector('span:first-child');
          if (lbl && btn._origLabel) lbl.textContent = btn._origLabel;
        }
        // last-ditch: native add
        window.location = getRoute('cart_url', '/cart');
      });
  }

  /* Render Dawn's cart drawer from the /cart/add.js sections response.
     Syncs the inner markup AND the is-empty class (the bit Dawn misses on
     first-add, which is what leaves the drawer looking blank). */
  function renderCartDrawer(data) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || !data.sections || !data.sections['cart-drawer']) return false;

    var tmp = document.createElement('div');
    tmp.innerHTML = data.sections['cart-drawer'];

    var newInner = tmp.querySelector('#CartDrawer') || tmp.querySelector('.drawer__inner');
    var curInner = cartDrawer.querySelector('#CartDrawer') || cartDrawer.querySelector('.drawer__inner');

    if (newInner && curInner) {
      curInner.innerHTML = newInner.innerHTML;
      curInner.className = newInner.className; // carries (or clears) is-empty
    } else {
      var newCD = tmp.querySelector('cart-drawer');
      cartDrawer.innerHTML = newCD ? newCD.innerHTML : tmp.innerHTML;
    }

    // belt-and-suspenders: make sure nothing is still flagged empty
    cartDrawer.classList.remove('is-empty');
    var di = cartDrawer.querySelector('.drawer__inner');
    if (di) di.classList.remove('is-empty');

    // cart icon bubble (count) — already in the same response, no extra fetch
    if (data.sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var t2 = document.createElement('div');
        t2.innerHTML = data.sections['cart-icon-bubble'];
        var fresh = t2.querySelector('#cart-icon-bubble') || t2.firstElementChild;
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }
    }
    return true;
  }

  function openCartDrawer(cartDrawer) {
    if (typeof cartDrawer.open === 'function') { try { cartDrawer.open(); return; } catch (e) {} }
    cartDrawer.classList.add('active', 'animate');
    cartDrawer.removeAttribute('inert');
    document.body.classList.add('overflow-hidden');
  }

  function replaceCartSections(sections) {
    Object.keys(sections).forEach(function (key) {
      var sel = '#shopify-section-' + key;
      var target = document.querySelector(sel) || document.getElementById(key);
      if (!target) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = sections[key];
      var fresh = tmp.querySelector(sel) || tmp.firstElementChild;
      if (fresh) target.innerHTML = fresh.innerHTML;
    });
  }

  function showFormError(form, msg) {
    var wrap = form.querySelector('.product-form__error-message-wrapper');
    var span = form.querySelector('.product-form__error-message');
    if (span) span.textContent = msg;
    if (wrap) wrap.hidden = false;
  }
  function clearFormError(form) {
    var wrap = form.querySelector('.product-form__error-message-wrapper');
    if (wrap) wrap.hidden = true;
  }

  document.addEventListener('submit', function (e) {
    var form = closest(e.target, '.np-root .np-form');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-cta-add]');
    addToCart(form, btn);
  });

  document.addEventListener('click', function (e) {
    var t = e.target;

    /* Rating row → smooth-scroll to reviews */
    var revBtn = closest(t, '.np-root [data-scroll-reviews]');
    if (revBtn) {
      var rev = document.querySelector('.np-root .reviews');
      if (rev) {
        var ry = rev.getBoundingClientRect().top + (window.pageYOffset || window.scrollY) - 16;
        window.scrollTo({ top: ry, behavior: 'smooth' });
      }
      return;
    }

    /* Gallery thumbnails */
    var thumb = closest(t, '.np-root .thumb');
    if (thumb) {
      var gallery = closest(thumb, '.gallery');
      if (gallery) {
        gallery.querySelectorAll('.thumb').forEach(function (b) { b.classList.remove('active'); });
        thumb.classList.add('active');
        var mainImg = gallery.querySelector('.gallery-main img');
        var full = thumb.getAttribute('data-full') || (thumb.querySelector('img') && thumb.querySelector('img').src);
        if (mainImg && full) {
          var alt = thumb.querySelector('img') && thumb.querySelector('img').alt;
          var swap = function () {
            mainImg.removeAttribute('srcset');
            mainImg.removeAttribute('sizes');
            mainImg.src = full;
            if (alt) mainImg.alt = alt;
            mainImg.style.opacity = '1';
          };
          // crossfade; image is preloaded so the new src paints immediately
          mainImg.style.opacity = '0.35';
          var pre = new Image();
          pre.onload = swap;
          pre.onerror = swap;
          pre.src = full;
          if (pre.complete) swap();
        }
        // video thumbs: swap the whole stage if data-video present
        var vid = thumb.getAttribute('data-video');
        var stage = gallery.querySelector('.gallery-main');
        if (stage) {
          var existing = stage.querySelector('video.gallery-video');
          if (vid) {
            if (!existing) {
              existing = document.createElement('video');
              existing.className = 'gallery-video';
              existing.setAttribute('controls', '');
              existing.setAttribute('playsinline', '');
              stage.appendChild(existing);
            }
            existing.src = vid;
            existing.style.display = 'block';
            if (mainImg) mainImg.style.display = 'none';
          } else {
            if (existing) existing.style.display = 'none';
            if (mainImg) mainImg.style.display = 'block';
          }
        }
      }
      return;
    }

    /* Format selector (PDF vs App) */
    var fmt = closest(t, '.np-root .fmt-card');
    if (fmt) {
      var stackWrap = closest(fmt, '[data-buybox]') || closest(fmt, '.buy');
      var stack = closest(fmt, '.format-stack');
      if (stack) {
        stack.querySelectorAll('.fmt-card').forEach(function (c) { c.classList.remove('fmt-active'); });
        fmt.classList.add('fmt-active');
      }
      applyFormat(stackWrap || document, fmt.getAttribute('data-format'), fmt);
      return;
    }

    /* Buy-box product info accordion */
    var bq = closest(t, '.np-root .buy-acc-q');
    if (bq) {
      var bitem = closest(bq, '.buy-acc-item');
      if (bitem) {
        var wasOpen = bitem.classList.contains('open');
        var list = closest(bitem, '.buy-accordion');
        if (list) list.querySelectorAll('.buy-acc-item').forEach(function (it) { it.classList.remove('open'); });
        if (!wasOpen) bitem.classList.add('open');
      }
      return;
    }

    /* FAQ accordion */
    var fq = closest(t, '.np-root .faq-q');
    if (fq) {
      var fitem = closest(fq, '.faq-item');
      if (fitem) {
        var wo = fitem.classList.contains('open');
        var flist = closest(fitem, '.faq-list');
        if (flist) flist.querySelectorAll('.faq-item').forEach(function (it) { it.classList.remove('open'); });
        if (!wo) fitem.classList.add('open');
      }
      return;
    }

    /* Methodology phase tabs */
    var mtab = closest(t, '.np-root .method-tab');
    if (mtab) {
      var msec = closest(mtab, '.method');
      if (msec) {
        var idx = Array.prototype.indexOf.call(mtab.parentNode.querySelectorAll('.method-tab'), mtab);
        msec.querySelectorAll('.method-tab').forEach(function (b) { b.classList.remove('active'); });
        mtab.classList.add('active');
        msec.querySelectorAll('.method-panel').forEach(function (p, i) {
          p.hidden = (i !== idx);
        });
      }
      return;
    }

    /* Trusted-by arrows */
    var arrow = closest(t, '.np-root .tba-arrow');
    if (arrow) {
      var tba = closest(arrow, '.tba');
      if (tba) {
        var dir = arrow.getAttribute('data-dir') === 'prev' ? -1 : 1;
        tbaScroll(tba, dir, true);
      }
      return;
    }

    /* Trusted-by dots */
    var dot = closest(t, '.np-root .tba-dot');
    if (dot) {
      var tbad = closest(dot, '.tba');
      if (tbad) {
        var track = tbad.querySelector('.tba-track');
        var i2 = parseInt(dot.getAttribute('data-i'), 10) || 0;
        var card = track && track.querySelector('.tba-card');
        if (track && card) {
          track.scrollTo({ left: i2 * (card.offsetWidth + 20), behavior: 'smooth' });
          tbad._paused = true;
          clearTimeout(tbad._resume);
          tbad._resume = setTimeout(function () { tbad._paused = false; }, 8000);
        }
      }
      return;
    }

    /* Review reels — inline play / pause */
    var rreel = closest(t, '.np-root .rev-reel');
    if (rreel && !closest(t, '.rev-reel-expand')) {
      var wrap = closest(rreel, '.rev-reels');
      var isPlaying = rreel.classList.contains('is-playing');
      if (wrap) {
        wrap.querySelectorAll('.rev-reel.is-playing').forEach(function (r) {
          r.classList.remove('is-playing');
          var ov = r.querySelector('video'); if (ov) { ov.pause(); }
        });
      }
      if (!isPlaying) {
        rreel.classList.add('is-playing');
        var v = rreel.querySelector('video');
        if (v) { v.muted = false; v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      } else {
        var v2 = rreel.querySelector('video'); if (v2) v2.pause();
      }
      return;
    }

    /* Athlete reels (buy box) — open lightbox */
    var rtile = closest(t, '.np-root .reel-tile');
    if (rtile) {
      var lb = document.querySelector('.np-root .reel-lightbox[data-lightbox]') || rtile.closest('.np-root').querySelector('.reel-lightbox');
      openReelLightbox(rtile);
      return;
    }
    /* expand icon on a review reel → also lightbox */
    var expand = closest(t, '.np-root .rev-reel-expand');
    if (expand) {
      e.stopPropagation();
      openReelLightbox(closest(expand, '.rev-reel'));
      return;
    }

    /* Lightbox controls */
    var lbClose = closest(t, '.np-root .reel-close');
    var lbBackdrop = t.classList && t.classList.contains('reel-lightbox');
    if (lbClose || lbBackdrop) { closeReelLightbox(); return; }
    var lbPrev = closest(t, '.np-root .reel-nav-prev');
    if (lbPrev) { e.stopPropagation(); cycleLightbox(-1); return; }
    var lbNext = closest(t, '.np-root .reel-nav-next');
    if (lbNext) { e.stopPropagation(); cycleLightbox(1); return; }

    /* VSL play / pause */
    var vsl = closest(t, '.np-root .vsl');
    if (vsl) {
      var vv = vsl.querySelector('video');
      if (vv) {
        if (vv.paused) { vv.play(); vsl.classList.add('vsl-playing'); }
        else { vv.pause(); vsl.classList.remove('vsl-playing'); }
      } else {
        vsl.classList.toggle('vsl-playing');
      }
      return;
    }
  });

  /* ---------- Format apply ---------- */
  function applyFormat(scope, format, card) {
    scope = scope || document;
    var addBtn = scope.querySelector('[data-cta-add]');
    var extLink = scope.querySelector('[data-cta-external]');
    var variantInput = scope.querySelector('[data-variant-input]');
    if (format === 'app') {
      if (addBtn) addBtn.hidden = true;
      if (extLink) {
        extLink.hidden = false;
        var url = card && card.getAttribute('data-external-url');
        if (url) extLink.href = url;
      }
    } else {
      if (extLink) extLink.hidden = true;
      if (addBtn) addBtn.hidden = false;
      if (variantInput && card) {
        var vid = card.getAttribute('data-variant-id');
        if (vid) variantInput.value = vid;
      }
    }
  }

  /* ============================================================
     LIGHTBOX (athlete / review reels expand)
     ============================================================ */
  var _lbRoot = null, _lbItems = [], _lbIndex = 0;

  function buildLightboxFrom(tile) {
    var section = tile.closest('.np-root');
    if (!section) return;
    var lb = section.querySelector('.reel-lightbox');
    if (!lb) return;
    _lbRoot = lb;
    // gather siblings in same group
    var group = tile.closest('.reels-grid, .rev-reels');
    _lbItems = group ? Array.prototype.slice.call(group.querySelectorAll('[data-reel]')) : [tile];
    _lbIndex = _lbItems.indexOf(tile.closest('[data-reel]') || tile);
    if (_lbIndex < 0) _lbIndex = 0;
  }

  function renderLightbox() {
    if (!_lbRoot || !_lbItems.length) return;
    var item = _lbItems[_lbIndex];
    var frame = _lbRoot.querySelector('.reel-frame');
    if (!frame) return;
    var bg = item.getAttribute('data-accent');
    var video = item.getAttribute('data-video');
    var caption = item.getAttribute('data-caption') || '';
    var mono = item.getAttribute('data-mono') || '';
    frame.innerHTML = '';
    if (bg) frame.style.background = bg;
    if (video) {
      var v = document.createElement('video');
      v.src = video; v.setAttribute('controls', ''); v.setAttribute('autoplay', ''); v.setAttribute('playsinline', '');
      v.className = 'reel-frame-video';
      frame.appendChild(v);
    } else {
      var grain = document.createElement('div'); grain.className = 'reel-frame-grain'; frame.appendChild(grain);
      var m = document.createElement('span'); m.className = 'reel-frame-mono'; m.textContent = mono; frame.appendChild(m);
      var prog = document.createElement('div'); prog.className = 'reel-progress'; prog.innerHTML = '<span class="reel-progress-bar"></span>'; frame.appendChild(prog);
    }
    if (caption) {
      var c = document.createElement('div'); c.className = 'reel-frame-caption'; c.textContent = caption; frame.appendChild(c);
    }
  }

  function openReelLightbox(tile) {
    if (!tile) return;
    buildLightboxFrom(tile);
    if (!_lbRoot) return;
    renderLightbox();
    _lbRoot.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeReelLightbox() {
    if (!_lbRoot) return;
    var v = _lbRoot.querySelector('video'); if (v) v.pause();
    _lbRoot.classList.remove('open');
    document.body.style.overflow = '';
  }
  function cycleLightbox(dir) {
    if (!_lbItems.length) return;
    _lbIndex = (_lbIndex + dir + _lbItems.length) % _lbItems.length;
    renderLightbox();
  }
  document.addEventListener('keydown', function (e) {
    if (!_lbRoot || !_lbRoot.classList.contains('open')) return;
    if (e.key === 'Escape') closeReelLightbox();
    else if (e.key === 'ArrowRight') cycleLightbox(1);
    else if (e.key === 'ArrowLeft') cycleLightbox(-1);
  });

  /* ============================================================
     TRUSTED-BY CAROUSEL (per-section autoplay + dots)
     ============================================================ */
  function tbaScroll(tba, dir, manual) {
    var track = tba.querySelector('.tba-track');
    if (!track) return;
    var card = track.querySelector('.tba-card');
    if (!card) return;
    var cardW = card.offsetWidth + 20;
    var maxScroll = track.scrollWidth - track.clientWidth;
    var next = track.scrollLeft + dir * cardW;
    if (dir > 0 && next >= maxScroll - 2) next = 0;
    if (dir < 0 && next < 0) next = maxScroll;
    track.scrollTo({ left: next, behavior: 'smooth' });
    if (manual) {
      tba._paused = true;
      clearTimeout(tba._resume);
      tba._resume = setTimeout(function () { tba._paused = false; }, 8000);
    }
  }

  function initTrustedBy(scope) {
    (scope || document).querySelectorAll('.np-root .tba').forEach(function (tba) {
      if (tba._inited) return;
      tba._inited = true;
      var track = tba.querySelector('.tba-track');
      if (!track) return;
      // update dots on scroll
      track.addEventListener('scroll', function () {
        var card = track.querySelector('.tba-card');
        if (!card) return;
        var i = Math.round(track.scrollLeft / (card.offsetWidth + 20));
        tba.querySelectorAll('.tba-dot').forEach(function (d, di) { d.classList.toggle('active', di === i); });
      }, { passive: true });
      // pause on interaction
      track.addEventListener('mouseenter', function () { tba._paused = true; });
      track.addEventListener('mouseleave', function () { tba._paused = false; });
      track.addEventListener('touchstart', function () { tba._paused = true; }, { passive: true });
      // autoplay
      if (tba.getAttribute('data-autoplay') !== 'false') {
        clearInterval(tba._timer);
        tba._timer = setInterval(function () {
          if (tba._paused) return;
          tbaScroll(tba, 1, false);
        }, 5500);
      }
    });
  }

  /* ============================================================
     STICKY ADD-TO-CART
     ============================================================ */
  function initStickyCart(scope) {
    (scope || document).querySelectorAll('.np-root .sticky-cart').forEach(function (bar) {
      if (bar._inited) return;
      bar._inited = true;
      var onScroll = function () {
        var y = window.scrollY || window.pageYOffset;
        var docH = document.body.scrollHeight - window.innerHeight;
        bar.classList.toggle('visible', y > 760 && y < (docH - 360));
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  /* ============================================================
     INIT
     ============================================================ */
  function initGallery(scope) {
    (scope || document).querySelectorAll('.np-root .gallery').forEach(function (gallery) {
      if (gallery._inited) return;
      gallery._inited = true;
      // Preload every full-size image so thumbnail clicks swap instantly
      gallery.querySelectorAll('.thumb[data-full]').forEach(function (th) {
        var url = th.getAttribute('data-full');
        if (url) { var im = new Image(); im.decoding = 'async'; im.src = url; }
      });
      // Smooth crossfade on the main image
      var mainImg = gallery.querySelector('.gallery-main img');
      if (mainImg) mainImg.style.transition = 'opacity .18s ease';
    });
  }

  function initAll(scope) {
    initGallery(scope);
    initTrustedBy(scope);
    initStickyCart(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Theme editor: re-init the reloaded section
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('.tba').forEach(function (tba) { clearInterval(tba._timer); });
  });
})();
